var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1300px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/system/company.png") },
        }),
        _vm._v("查看成员 "),
        _c("span", { staticClass: "title-tips" }, [
          _vm._v(_vm._s(_vm.rowData.wbName)),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: {
                  size: "small",
                  placeholder: "请输入内容",
                  "suffix-icon": "el-icon-search",
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px", "margin-left": "10px" },
                  attrs: { size: "small", placeholder: "请选择" },
                  model: {
                    value: _vm.isActived,
                    callback: function ($$v) {
                      _vm.isActived = $$v
                    },
                    expression: "isActived",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "add",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible2 = true
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-circle-plus",
                    staticStyle: {
                      "font-size": "20px",
                      "vertical-align": "middle",
                    },
                  }),
                  _vm._v(" 添加成员 "),
                ]
              ),
            ],
            1
          ),
          _c("BaseTable", {
            attrs: {
              height: 500,
              tableData: {
                ..._vm.tableData,
                columns: _vm.columns,
              },
              isPager: false,
              loading: _vm.loading,
            },
            scopedSlots: _vm._u([
              {
                key: "companyName",
                fn: function (row) {
                  return [_c("p", [_vm._v(_vm._s(row.scope.wbName))])]
                },
              },
              {
                key: "yy",
                fn: function (row) {
                  return [
                    _c("img", {
                      staticClass: "license",
                      attrs: {
                        src: require("@/assets/images/system/license.png"),
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.viewImg(row.scope, 1)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
              {
                key: "phone",
                fn: function (row) {
                  return [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [_vm._v(" 手机 ")]),
                      _vm._v(" " + _vm._s(row.scope.phoneNumber || "--") + " "),
                    ]),
                    _c("p", [
                      _c("span", { staticClass: "label" }, [_vm._v(" 邮箱 ")]),
                      _vm._v(" " + _vm._s(row.scope.email || "--") + " "),
                    ]),
                  ]
                },
              },
              {
                key: "status",
                fn: function (row) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "status",
                        class: `status-${!!row.scope.isActived}`,
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(row.scope.isActived ? "启用" : "停用") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "typeExt",
                fn: function (row) {
                  return [
                    !row.scope.dataType
                      ? _c("span", [_vm._v(_vm._s(row.scope.typeExt))])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "applyStatusExt",
                fn: function (row) {
                  return [
                    !row.scope.dataType
                      ? _c("span", [_vm._v(_vm._s(row.scope.applyStatusExt))])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "opt",
                fn: function (row) {
                  return [
                    _c(
                      "div",
                      { staticClass: "opt" },
                      [
                        !row.scope.dataType
                          ? [
                              row.scope.type !== 166
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "view-menber",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setAdmin(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v(" 设为管理员 ")]
                                  )
                                : _vm._e(),
                              row.scope.type === 166
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "view-menber",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeAdmin(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v(" 移除管理权 ")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "view-menber",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editUser(row.scope)
                                    },
                                  },
                                },
                                [_vm._v(" 修改信息 ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "view-menber",
                                  on: {
                                    click: function ($event) {
                                      return _vm.disptchMember(row.scope)
                                    },
                                  },
                                },
                                [_vm._v(" 成员调度 ")]
                              ),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "8px" } },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "inactive-color": "#ff4949",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeIsActived(row.scope)
                                      },
                                    },
                                    model: {
                                      value: row.scope.isActived,
                                      callback: function ($$v) {
                                        _vm.$set(row.scope, "isActived", $$v)
                                      },
                                      expression: "row.scope.isActived",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.scope.isActived ? "启用" : "停用"
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass: "view-menber",
                                  on: {
                                    click: function ($event) {
                                      return _vm.passUser(row.scope)
                                    },
                                  },
                                },
                                [_vm._v(" 审核通过 ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "view-menber",
                                  on: {
                                    click: function ($event) {
                                      return _vm.refuseUser(row.scope)
                                    },
                                  },
                                },
                                [_vm._v(" 审核拒绝 ")]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("UpdateUserDialog", {
        attrs: { rowData: _vm.editData, dialogVisible: _vm.dialogVisible1 },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("AddUserDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2, rowData: _vm.rowData },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("DisptchMemberDialog", {
        attrs: { dialogVisible: _vm.dialogVisible3, rowData: _vm.editData },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }